export function getFilenameFromContentDisposition(header, fallback = 'download') {
    if (!header || typeof header !== 'string') return fallback;
    
    try {
        /* RFC 5987 style: filename*=UTF-8''... */
        const utf8Match = header.match(/filename\*=UTF-8''([^;]+)\s*/i);
        
        if (utf8Match && utf8Match[1]) {
            return decodeURIComponent(utf8Match[1].replace(/"/g, ''));
        }
        
        /* Basic: filename="..." or filename=... */
        const asciiMatch = header.match(/filename\s*=\s*"?([^";]+)"?/i);
        if (asciiMatch && asciiMatch[1]) {
            return asciiMatch[1];
        }
    } catch (_) {
        /* ignore */
    }
    return fallback;
}
